<template>
	<JBox class="s-w-full s-bg-gray-100 s-min-h-screen">
		<!-- Max width wrapper -->
		<JBox class="s-p-4 s-max-w-6xl s-m-auto s-mt-4">
			<!-- Headline -->
			<JBox class="s-w-full s-flex s-items-center s-mb-4 ">
				<JBox class="s-w-1/2">
					<JHeadline class="s-text-2xl">{{ $t("products.products") }} ({{ totalCount }})</JHeadline>
				</JBox>
				<JFlex class="s-w-1/2 s-flex s-justify-end s-items-center">
					<JSpinner variant="indigo" type="dots" :delay="0" v-if="isLoading" class="s-mr-2" />
					<JButton @click="initCreateProduct">
						{{ $t("products.createProduct") }}
					</JButton>
				</JFlex>
			</JBox>

			<!-- When there are some products -->
			<template>
				<!-- TODO: we have to add search but how to do it if we have products with versions grouped like this? -->
				<!-- Search -->
				<!-- <JBox class="s-w-full s-mb-4">
					<JInputText v-model="textSearch" :placeholder="$t('products.searchProductsPlaceholder')" @input="search" />
				</JBox> -->

				<!-- Products -->
				<CTable :header="[{ label: $t('products.plan') }, { label: $t('products.type') }, { label: '' }]" :list="products">
					<template v-slot="{ item }">
						<CTableRow class="hover:s-bg-gray-50 s-cursor-pointer" @click="toggleExpandProduct(item)">
							<CTableCell> {{ item.productId ? item.productId.plan : null }}</CTableCell>
							<CTableCell> {{ item.productId ? item.productId.type : null }}</CTableCell>
							<CTableCell class="s-text-right">
								<JFlex class="s-justify-end">
									<CIcon name="chevron-down" class="s-w-5 s-h-5" />
								</JFlex>
							</CTableCell>
						</CTableRow>
						<CTableRow v-if="expandedProducts.indexOf(item.hash) > -1">
							<CTableCell colspan="3" variant="ghost">
								<JBox class="s-bg-gray-200 s-p-6">
									<JBox>
										<JFlex class="s-justify-end s-mb-2 s-items-center">
											<JHeadline>{{ $t("products.versions") }}</JHeadline>
											<JFlex class="s-w-1/2 s-justify-end">
												<JButton
													@click="
														initCreateProduct({
															plan: item.productId.plan,
															type: item.productId.type,
															name: item.name,
															insurerId: item.insurer && item.insurer.id
														})
													"
													variant="default-sm"
												>
													{{ $t("products.createVersion") }}
												</JButton>
											</JFlex>
										</JFlex>
										<CTable :header="[{ label: $t('products.name') }, { label: $t('products.version') }]" :list="item.versions">
											<template v-slot="{ item }">
												<CTableRow class="hover:s-bg-gray-50 s-cursor-pointer" @click="goToProduct(item.productId)">
													<CTableCell>
														<JText class="s-text-indigo-600">{{ item.name }}</JText>
													</CTableCell>
													<CTableCell> {{ item.productId.version }}</CTableCell>
												</CTableRow>
											</template>
										</CTable>
									</JBox>
								</JBox>
							</CTableCell>
						</CTableRow>
					</template>
				</CTable>
			</template>

			<!-- Empty State -->
			<JBox
				v-if="!products.length && !isLoading"
				@click="initCreateProduct"
				class="s-flex s-justify-center s-items-center s-h-48 s-bg-white s-rounded-lg s-cursor-pointer s-border-4 s-border-dotted s-border-gray-400 hover:s-border-indigo-400 s-transition s-ease-in s-duration-100"
			>
				{{ $t("products.addNewProduct") }}
			</JBox>

			<!-- Create Product Modal -->
			<Portal to="layer0">
				<CModal :isVisible="showCreateModal">
					<ProductCreateForm @save="handleCreate" @cancel="showCreateModal = false" :initialState="versionToCreate" />
				</CModal>
			</Portal>

			<!-- Messaging -->
			<Portal to="layer2">
				<CMessage />
			</Portal>
		</JBox>
	</JBox>
</template>

<script>
import ProductCreateForm from "../components/ProductCreateForm.vue"
import CTable from "@/modules/core/components/CTable"

export default {
	components: { ProductCreateForm, CTable },

	data() {
		return {
			isLoading: false,

			showCreateModal: false,
			versionToCreate: {}, // to pass plan and type into create modal when creating a version

			expandedProducts: []
		}
	},

	computed: {
		products() {
			return (
				this.$store.state?.products?.list?.products?.map(item => ({
					...item,
					hash: `${item?.productId?.type} ${item?.productId?.plan}`
				})) ?? []
			)
		},

		totalCount() {
			return this.$store.state?.products?.list?.totalCount ?? 0
		}
	},

	methods: {
		async fetchProducts() {
			this.isLoading = true
			const { isSuccess, error } = await this.$store.dispatch("products/fetchProducts")
			this.isLoading = false

			if (!isSuccess) {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: error }
				})
			}
		},

		async handleCreate({ plan, type, version, name, insurerId, benefitInputs }) {
			const { isSuccess, error } = await this.$store.dispatch("products/addProduct", {
				name,
				plan,
				type,
				version,
				insurerId,
				benefitInputs,
				locale: this.$store.getters.locale
			})

			if (!isSuccess) {
				this.$store.dispatch("addToastMessage", {
					type: "error",
					content: { type: "message", text: error }
				})
				return
			}

			this.showCreateModal = false
			this.versionToCreate = {}
		},

		initCreateProduct({ plan, type, name, insurerId }) {
			this.showCreateModal = true
			if (plan && type) this.versionToCreate = { plan, type, name, insurerId }
		},

		toggleExpandProduct(product) {
			const hash = product.hash

			if (this.expandedProducts.find(item => item === hash))
				this.expandedProducts = this.expandedProducts.filter(item => item !== hash)
			else this.expandedProducts.push(hash)
		},

		goToProduct(productId) {
			this.$router.push({
				name: "ViewProductsDetail",
				params: {
					productType: productId.type,
					productPlan: productId.plan,
					productVersion: productId.version
				}
			})
		}
	},

	created() {
		this.fetchProducts()
	}
}
</script>
